export default __webpack_public_path__ + "static/relatics-78d806c8ae344d30ca81d1b9ea27dbf1.png";